export const PREMIUMCOLUMNS = [{
  slots: {
    title: '保费'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  scopedSlots: {
    customRender: 'name'
  }
},
//   {
//     slots: {title: '折扣方式'},
//     dataIndex: 'discountMode',
//     key: 'discountMode',
//     align: 'center',
//     scopedSlots: {customRender: 'discountMode'},
//     width: 180
//   },
//   {
//     dataIndex: 'discountRatio',
//     key: 'discountRatio',
//     align: 'center',
//     scopedSlots: {customRender: 'discountRatio'},
//     width: 180,
//     slots: {title: '折扣比例'}
//   },
//   {
//     dataIndex: 'discountAmount',
//     key: 'discountAmount',
//     align: 'center',
//     scopedSlots: {customRender: 'discountAmount'},
//     width: 180,
//     slots: {title: '折扣价格'}
//   },
{
  dataIndex: 'discountAmount',
  key: 'discountAmount',
  align: 'center',
  scopedSlots: {
    customRender: 'discountAmount'
  },
  width: 180,
  slots: {
    title: '自定义价格'
  }
},
//   {
//     slots: {title: '折扣后'},
//     dataIndex: 'price',
//     key: 'price',
//     align: 'center',
//     scopedSlots: {customRender: 'price'}
//   },
{
  slots: {
    title: '适用架构'
  },
  dataIndex: 'structureIds',
  key: 'structureIds',
  align: 'center',
  scopedSlots: {
    customRender: 'structureIds'
  },
  width: 250
}];
export const PREMIUMCOLUMNS1 = [{
  slots: {
    title: '保费'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  scopedSlots: {
    customRender: 'name'
  }
},
//   {
//     slots: {title: '折扣方式'},
//     dataIndex: 'discountMode',
//     key: 'discountMode',
//     align: 'center',
//     scopedSlots: {customRender: 'discountMode'},
//     width: 180
//   },
//   {
//     dataIndex: 'discountRatio',
//     key: 'discountRatio',
//     align: 'center',
//     scopedSlots: {customRender: 'discountRatio'},
//     width: 180,
//     slots: {title: '折扣比例'}
//   },
//   {
//     dataIndex: 'discountAmount',
//     key: 'discountAmount',
//     slots: {title: '折扣价格'},
//     align: 'center',
//     scopedSlots: {customRender: 'discountAmount'},
//     width: 180
//   },
//   {
//     slots: {title: '折扣后'},
//     dataIndex: 'price',
//     key: 'price',
//     align: 'center',
//     scopedSlots: {customRender: 'price'}
//   },
{
  dataIndex: 'discountAmount',
  key: 'discountAmount',
  align: 'center',
  scopedSlots: {
    customRender: 'discountAmount'
  },
  width: 180,
  slots: {
    title: '自定义价格'
  }
}, {
  slots: {
    title: '适用架构'
  },
  dataIndex: 'structureIds',
  key: 'structureIds',
  align: 'center',
  scopedSlots: {
    customRender: 'structureIds'
  },
  width: 250
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: 'action',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 90
}];